var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.01 13.333h-30c-.916 0-1.666-.75-1.666-1.666 0-.917.75-1.667 1.667-1.667h30c.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666zm1.667 7.25c0-.916-.75-1.666-1.666-1.666H22.76c-.917 0-1.667.75-1.667 1.666 0 .917.75 1.667 1.667 1.667h17.25c.916 0 1.666-.75 1.666-1.667zm0 8.875c0-.916-.75-1.666-1.666-1.666H17.677c-.916 0-1.666.75-1.666 1.666 0 .917.75 1.667 1.666 1.667h22.334c.916 0 1.666-.75 1.666-1.667zm-.125 8.875c0-.916-.75-1.666-1.666-1.666H11.51c-.917 0-1.667.75-1.667 1.666 0 .917.75 1.667 1.667 1.667h28.375c.916 0 1.666-.75 1.666-1.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconMobile);
export default __webpack_public_path__ + "static/media/navIconMobile.9925b882.svg";
export { ForwardRef as ReactComponent };